import { render, staticRenderFns } from "./NormalSearchNav396.vue?vue&type=template&id=37b50f32&scoped=true&"
import script from "./NormalSearchNav396.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav396.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b50f32",
  null
  
)

export default component.exports